import { Box, Chip, Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { LEAD_ORDER_PAYMENT_STATUS } from '../../../../utils/utils';

const SERVICE_TYPES = {
    'all': 'Tất cả',
    'viet': 'Việt',
    'han': 'Hàn'
};

const ActiveFilters = ({ 
    startDate, 
    endDate, 
    status,
    selectedStaffs,
    serviceGroup,
    serviceType,
    serviceGroups,
    onClearFilter
}) => {
    const hasActiveFilters = status !== null || selectedStaffs.length > 0 || serviceGroup !== null || serviceType !== 'all';

    if (!hasActiveFilters) return null;

    const getServiceGroupName = (id) => {
        const group = serviceGroups.find(g => g.id === id);
        return group ? group.name : '';
    };

    return (
        <Box sx={{ px: 3, py: 1 }}>
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" gap={1}>
                <Typography variant="caption" color="text.secondary">
                    Bộ lọc đang áp dụng:
                </Typography>
                
                {/* Date Range Filter - Always shown without delete option */}
                <Chip
                    label={`Thời gian: ${dayjs(startDate).format('DD/MM/YYYY')} - ${dayjs(endDate).format('DD/MM/YYYY')}`}
                    size="small"
                    color="primary"
                    variant="outlined"
                />

                {/* Service Group Filter */}
                {serviceGroup !== null && (
                    <Chip
                        label={`Nhóm dịch vụ: ${getServiceGroupName(serviceGroup)}`}
                        size="small"
                        onDelete={() => onClearFilter('serviceGroup')}
                    />
                )}

                {/* Service Type Filter */}
                {serviceType !== 'all' && (
                    <Chip
                        label={`Loại dịch vụ: ${SERVICE_TYPES[serviceType]}`}
                        size="small"
                        onDelete={() => onClearFilter('serviceType')}
                    />
                )}

                {/* Status Filter */}
                {status !== null && (
                    <Chip
                        label={`Trạng thái: ${LEAD_ORDER_PAYMENT_STATUS[status]}`}
                        size="small"
                        onDelete={() => onClearFilter('status')}
                    />
                )}

                {/* Staff Filters */}
                {selectedStaffs.map((staff) => (
                    <Chip
                        key={staff.value}
                        label={`Nhân viên: ${staff.label}`}
                        size="small"
                        onDelete={() => onClearFilter('staff', staff.value)}
                    />
                ))}
            </Stack>
        </Box>
    );
};

export default ActiveFilters; 